import React from 'react';

interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
}

const Slider: React.FC<SliderProps> = ({ label, value, min, max, step, onChange, ...props }) => {
  const displayValue = typeof value === 'number' ? value : 0;

  const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#94a3b8',
    marginBottom: '0.5rem',
    fontSize: '0.875rem',
  };
  const sliderContainerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  };
  const sliderStyle: React.CSSProperties = {
    width: '100%',
    flex: 1,
    accentColor: '#8b5cf6',
  };
  const valueStyle: React.CSSProperties = {
    color: '#cbd5e1',
    fontSize: '0.875rem',
    minWidth: '40px',
    textAlign: 'right',
  };
  
  return (
    <div style={{ marginBottom: '1rem' }} {...props}>
      <label style={labelStyle}>{label}</label>
      <div style={sliderContainerStyle}>
        <input 
          type="range" 
          min={min} 
          max={max} 
          step={step} 
          value={displayValue}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          style={sliderStyle}
        />
        <span style={valueStyle}>{displayValue.toFixed(2)}</span>
      </div>
    </div>
  );
};

export default Slider; 